import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/reimbursementTypes';

export const submitAdmission =
  (form: any, isEdit: boolean, onSuccess: any, onError: any)
    : Action<any[]> => {
    return {
      type: actionTypes.SUBMIT_REIMBURSEMENT_ADMISSION, ...{ form, isEdit, onSuccess, onError },
    };
  };

export const generateOTP = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return {
    type: actionTypes.GENERATE_REIMBURSEMENT_OTP, ...{ payload, onSuccess, onError },
  };
};

export const verifyOTP = (payload: any, onSuccess: any, onError: any): Action<any[]> => {
  return {
    type: actionTypes.VERIFY_REIMBURSEMENT_OTP, ...{ payload, onSuccess, onError },
  };
};

export const updateRIClaimData = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_REIMBURSEMENT_DETAIL, payload);

export const resetReimbursement = (): Action<void> =>
  updateAction(actionTypes.RESET_REIMBURSEMENT);

export const showIRModal = (visible: boolean): Action<any> =>
  updateAction(actionTypes.SHOW_IR_MODAL, visible);

export const submitReimbursementIr = (form: any, onSuccess: any, onError: any): Action<any> =>
  updateAction(actionTypes.SUBMIT_REIMBURSEMENT_IR, { form, onSuccess, onError });

export const setOTPModalVisible = (payload: boolean): Action<any> => {
  return updateAction(actionTypes.SET_OTP_MODAL_VISIBLE, payload);
};
